import { t } from '@/features/i18n/utils';
import { useEffect, useState } from 'react';
import { Spinner } from '@/ui/components/spinner';

const authMessages = [
  { en: 'Connecting you to Volve', nb: 'Kobler deg til Volve' },
  { en: 'Preparing your workspace', nb: 'Klargjør arbeidsområdet ditt' },
  { en: 'Getting everything ready', nb: 'Gjør alt klart' },
] as const;

const workspaceMessages = [
  { en: 'Bringing your projects into view', nb: 'Henter frem prosjektene dine' },
  { en: 'Gathering the latest information', nb: 'Samler den nyeste informasjonen' },
  { en: 'Organising your workspace', nb: 'Organiserer arbeidsområdet ditt' },
  { en: 'Preparing the relevant files', nb: 'Klargjør de relevante filene' },
  { en: 'Connecting the relevant details', nb: 'Kobler sammen de relevante detaljene' },
  { en: 'Preparing what matters', nb: 'Forbereder det som er viktig' },
  { en: 'Bringing everything together', nb: 'Samler alt på ett sted' },
] as const;

export function LoadingState({ context = 'workspace' }: { context?: 'auth' | 'workspace' }) {
  const messages = context === 'auth' ? authMessages : workspaceMessages;
  const [messageIndex, setMessageIndex] = useState(() =>
    Math.floor(Math.random() * messages.length),
  );
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let changeTimeout: number | undefined;
    let interval: number | undefined;
    const revealTimeout = window.setTimeout(() => {
      setVisible(true);
      interval = window.setInterval(() => {
        setVisible(false);
        changeTimeout = window.setTimeout(() => {
          setMessageIndex((index) => index + 1);
          setVisible(true);
        }, 150);
      }, 2_500);
    }, 600);

    return () => {
      window.clearTimeout(revealTimeout);
      window.clearTimeout(changeTimeout);
      window.clearInterval(interval);
    };
  }, []);

  return (
    <div role="status" className="absolute inset-0 flex flex-col items-center justify-center gap-3">
      <span className="relative size-5">
        <Spinner kind="inset" aria-hidden />
      </span>
      <span className="sr-only">{t({ en: 'Loading', nb: 'Laster' })}</span>
      <span
        aria-hidden
        data-visible={visible || undefined}
        className="h-5 text-sm text-muted opacity-0 transition-opacity duration-150 motion-reduce:transition-none data-visible:opacity-100"
      >
        {t(messages[messageIndex % messages.length] ?? messages[0])}
      </span>
    </div>
  );
}
